export { PricesBodyRow } from './PricesBodyRow'



// WEBPACK FOOTER //
// ./src/components/Prices/components/index.js